import { render, staticRenderFns } from "./DiscountCredentialsDetails.vue?vue&type=template&id=1bf3021a&scoped=true&"
import script from "./DiscountCredentialsDetails.vue?vue&type=script&lang=js&"
export * from "./DiscountCredentialsDetails.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCredentialsDetails.vue?vue&type=style&index=0&id=1bf3021a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3021a",
  null
  
)

export default component.exports